var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('a-config-provider',{attrs:{"getPopupContainer":_vm.getPopupContainer}},[_c('div',{staticClass:"app-provider-content"},[(_vm.showInternetConnectionAlert)?_c('internet-connection-alert'):_vm._e(),_c('app-layout',[_c('modals'),_c('permission-provider')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }